import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router';
import { AuthProvider } from 'react-oidc-context';
import { store } from './store/store';
import { oidcConfig } from './auth/constants';
import { router } from './router';
import { fetchApplicationSettings } from './infrastructure/config';
import { Component as NoPage } from './pages/NoPage';
import './index.css';

async function bootstrap() {
  await fetchApplicationSettings();
}

function renderRoot() {
  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <AuthProvider {...oidcConfig()}>
      <React.StrictMode>
        <Provider store={store}>
          <RouterProvider router={router} />
        </Provider>
      </React.StrictMode>
    </AuthProvider>
  );
}

function renderErrorPage() {
  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<NoPage />);
}

Promise.resolve().then(bootstrap).then(renderRoot).catch(renderErrorPage);
